import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/WOW11LRG.jpg')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>October 7, 2024</ClientTag>
                            <Title>Cholesterol</Title>
                            <TechniqueTitle>
                            The Good, The Bad, & The Balanced!
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>Cholesterol is a type of fat found within your blood. It is essential to build cells, produce hormones (like estrogen and testosterone), and make vitamin D.</p>
                    <p className='content'>There are two main types of cholesterol: Low- Density Lipoprotein (LDL) and High-Density Lipoprotein (HDL). HDL is often referred to as “good cholesterol”. This is because it helps remove excess cholesterol from the bloodstream, carrying it back to the liver, where it is processed and removed from the body. High levels of HDL can help protect against heart disease. LDL on the other hand is often referred to as “bad cholesterol”. This is because it can build up in the walls of your arteries, forming plaques that can lead to blockages. This increases the risk of cardiovascular problems like heart attacks and strokes. </p>
                     <p className='content'>When looking at risk factors for conditions such as metabolic syndrome, heart disease, and stroke, it is the ratio of HDL to LDL that is often looked at. Maintaining a healthy ratio cholesterol is often managed with a balanced diet, regular exercise, and in some cases prescribed medications and supplements. </p>

                  
                    <h3 className='my-5'>Tips to Holistically Manage Cholesterol</h3>
                    <div>
                      <p className='content'>1. Mediterranean Diet: This diet has been studied and shown to help reduce levels of LDL and raise levels of HDL. </p>
                      <p className='content'>2. Regular Exercise: Aiming to be moderately active for 30 minutes minimally daily can help to balance cholesterol levels. </p>
                      <p className='content'>3. Consistent Sleep: Sleeping for 6-9 hours each night can help the body balance cholesterol levels. </p>
                      <p className='content'>4. Herbal Remedies: Cinnamon, Psyllium, Hawthorn, Garlic, Holy Basil </p>
                      <p className='content'>5. Supplements: Omega-3s, Niacin, Red yeast rice, CoQ10, Olive oil, Vitamin E </p>
                      <p className='content'>6. Expert help: Speak with your Naturopathic Doctor to learn more about managing cholesterol levels </p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW11" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>

                      </ScrollTop>
                
                      <Footer />
                
                      </Fragment>
                    );
                  }
                }
                
                export default withRouter(Case);